import { render, staticRenderFns } from "./id-ai.vue?vue&type=template&id=0eec8212&scoped=true"
import script from "./id-ai.vue?vue&type=script&lang=ts"
export * from "./id-ai.vue?vue&type=script&lang=ts"
import style0 from "./id-ai.vue?vue&type=style&index=0&id=0eec8212&prod&lang=scss&scoped=true"
import style1 from "./id-ai.vue?vue&type=style&index=1&id=0eec8212&prod&lang=scss&scoped=true"
import style2 from "./id-ai.vue?vue&type=style&index=2&id=0eec8212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eec8212",
  null
  
)

export default component.exports